// tslint:disable: max-line-length
import axios from 'axios';
import { CreateDataByIndexedDB, GetAllDataByIndexedDB } from '../../indexed/index';
import moment from 'moment';
import axiosInstance from '../../helpers/interceptor';
import { userHotelDetails } from '../../helpers/handleBrandAndHotelData';

export const getSelfAssessment = async (assessmentId) => {
    const { selectedHotel } = userHotelDetails();
    const doesUpdate = async () => {
        const { data } = await axiosInstance.get(`${Env.API_URL}/customerAssessment/${assessmentId}?&isClientApp=true`);
        CreateDataByIndexedDB(`${Env.API_URL}/customerAssessment/${assessmentId}?&isClientApp=true`, data, selectedHotel);
    };
    const OfflineData = await GetAllDataByIndexedDB(`${Env.API_URL}/customerAssessment/${assessmentId}?&isClientApp=true`, selectedHotel);
    if (OfflineData) {
        doesUpdate();
        return OfflineData;
    }
    const { data } = await axiosInstance.get(`${Env.API_URL}/customerAssessment/${assessmentId}?&isClientApp=true`);
      
    return data;
};

export const getTemplate = async (assessmentId) => {
    const {selectedHotel} = userHotelDetails();

    const doesUpdate = async () => {
        const { data } = await axiosInstance.get(`${Env.API_URL}/customerAssessment/${assessmentId}/template?`);
        CreateDataByIndexedDB(`${Env.API_URL}/customerAssessment/${assessmentId}/template?`, data, selectedHotel);
    };
    
    const OfflineData = await GetAllDataByIndexedDB(`${Env.API_URL}/customerAssessment/${assessmentId}/template?`, selectedHotel);
    if (OfflineData) {
        doesUpdate();
        return OfflineData;
    }
    const { data } = await axiosInstance.get(`${Env.API_URL}/customerAssessment/${assessmentId}/template?`);
    return data;
};

export const deleteSelfAssessment = async (assessmentId) => {
    const { userData } = userHotelDetails();
    const { data } = await axios.delete(`${Env.API_URL}/customerAssessment/series/${assessmentId}`, {
        headers: {
            Authorization : `Bearer ${userData.accessToken}`,
        },
    });
    return data;
};

export const selfAssessmentsListForUser = async (payLoad) => {
    const {selectedHotel} = userHotelDetails();
    let isType = '';
    payLoad.assessedTag ? isType = 'tagged' : payLoad.radioCheck === 'sent' ? isType = 'created' : isType = 'assigned';
    const startDate = payLoad.startDate && moment(payLoad.startDate).startOf('day').toString();
    const endDate = payLoad.endDate && moment(payLoad.endDate).endOf('day').toString();

    const apiUrl = `${Env.API_URL}/customerAssessment/latest`;
    const payload: any = { pageSize: 10, page: payLoad.pageNumber, sort: payLoad.sort, hotelId: selectedHotel, isClientApp: true};
    if (payLoad.userId.length) {
        payload.userId = payLoad.userId;
    }
    if (!payLoad.selectedSelfAssessmentId) {
        payload.isType = isType;
    }
    if (startDate) {
        payload.startDate = startDate;
    }
    if (endDate) {
        payload.endDate = endDate;
    }
    if (payLoad.selectedFocusArea) {
        payload.arrSourceTemplateCategoryId = payLoad.selectedFocusArea;
    }
    if (payLoad.selfAssessmentStatus) {
        switch (payLoad.selfAssessmentStatus) {
            case 'overdue':
                payload.overdue = true;
                break;
            case 'completed':
                payload.isSubmitted = true;
                break;
            case 'ongoing':
                payload.isSubmitted = false;
                break;
        }
    }
    if (payLoad.selectedSelfAssessmentId) {
        payload.id = payLoad.selectedSelfAssessmentId;
    }
    if (payLoad.andOr !== undefined && payLoad.containUser.length) {
        payload.cond = payLoad.andOr;
    }
    if (payLoad.containUser.length) {
        payload.containUserId = payLoad.containUser;
    }
    
    const { data } = await axiosInstance.get(apiUrl, {
        params: payload,
    });

    return data;
};
